import React from "react";
import Row from "@amzn/meridian/row";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import { FormattedMessage } from "react-intl";

import {
  DEPARTED,
  PENDING_DEPART,
  PENDING_STAGE,
  PENDING_PICK,
  getRouteCountByStatus,
} from "../../outboundAmzl/RouteStatusManager";

const TabularGridViewARV2 = (props) => {
  let routeList = props.routeList;
  routeList = routeList.sort((a, b) => a.criticalPullTime - b.criticalPullTime);

  const routeWaveList = [];
  routeList.forEach((route) => {
    const wave = routeWaveList.find((wave) => {
      return wave.name === route.routeSLA;
    });
    if (wave) {
      wave.routeList.push(route);
    } else {
      routeWaveList.push({
        name: route.routeSLA,
        routeList: [route],
      });
    }
  });

  return (
    <div>
      <Row
        widths={["grid-12"]}
        alignmentVertical="top"
        spacingInset="small large"
      >
        <div>
          <Table
            showDividers={true}
            showStripes={true}
            headerRows={1}
            spacing="small"
          >
            <TableRow>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundARV2.wave"
                  defaultMessage="Wave"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.routesInCaps"
                  defaultMessage="Routes"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundARV2.inProgress"
                  defaultMessage="In progress"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundARV2.picked"
                  defaultMessage="Picked"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundARV2.staged"
                  defaultMessage="Staged"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundARV2.departed"
                  defaultMessage="Departed"
                />
              </TableCell>
            </TableRow>
            {routeWaveList.map((wave) => (
              <TableRow key={wave.name}>
                <TableCell alignmentHorizontal="right">{wave.name}</TableCell>
                <TableCell alignmentHorizontal="right">
                  {wave.routeList.length}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteCountByStatus(PENDING_PICK, wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteCountByStatus(PENDING_STAGE, wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteCountByStatus(PENDING_DEPART, wave.routeList)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  {getRouteCountByStatus(DEPARTED, wave.routeList)}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </div>
      </Row>
    </div>
  );
};

export default TabularGridViewARV2;



// WEBPACK FOOTER //
// ./src/components/outboundARv2/routegridview/TabularGridViewARV2.js